import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from './store'
import config from './config'
Vue.use(VueRouter);

const authChildRoutes = (prop) => [
    {
        path:'login',
        name: prop + '.login',
        component:() => import('@/pages/auth/Login.vue')
    },
    {
        path:'otp',
        name: prop + '.otp',
        component: () => import('@/pages/auth/Otp.vue')
    }
]

const otherRoutes = () => [
    {
        path:'/',
        name:'dashboard',
        component:() => import('./pages/dashboard/MainDashboard.vue'),
        meta: {  requiresAuth:true }
    },
    {
        path:'/operational-dashboard',
        name:'operational.dashboard',
        component:() => import('./pages/dashboard/OperationalDashboard.vue'),
        meta: {  requiresAuth:true }
    },
    {
        path:'/partner',
        name:'partner',
        component:() => import('./pages/partner/Partner.vue'),      
        meta: { requiresAuth:true }       
    },
    {
        path:'/rider',
        name:'rider',
        component:() => import('./pages/rider/Rider.vue'),   
        meta: { requiresAuth:true }          
    },
    {
        path:'/rider-advanced-salary',
        name:'rider.advanced_salary',
        component:() => import('./pages/rider/AdvancedSalary.vue'),   
        meta: { requiresAuth:true }          
    },
    {
        path:'/rider-monthly-salary',
        name:'rider.monthly_salary',
        component:() => import('./pages/rider/MonthlySalary.vue'),   
        meta: { requiresAuth:true }          
    },
    {
        path:'/rider-monthly-salary-create',
        name:'rider.monthly_salary_create',
        component:() => import('./pages/rider/MonthlySalaryCreate.vue'),   
        meta: { requiresAuth:true }          
    },
    {
        path:'/rider-salary-details',
        name:'rider.salary_details',
        component:() => import('./pages/rider/SalaryDetails.vue'),   
        meta: { requiresAuth:true }          
    },
    {
        path:'/hub',
        name:'hub',
        component:() => import('./pages/settings/Hub.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-dashboard',
        name:'hub.dashboard',
        component:() => import('./pages/Hub/Dashboard.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-cost',
        name:'hub.cost',
        component:() => import('./pages/Hub/Cost.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-return-list',
        name:'hub.return.list',
        component:() => import('./pages/Hub/ReturnList.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-return-form',
        name:'hub.return.form',
        component:() => import('./pages/Hub/ReturnForm.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-return-show-order',
        name:'hub.return.show.order',
        component:() => import('./pages/Hub/ReturnShowOrder.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-deposit',
        name:'hub.deposit',
        component:() => import('./pages/Hub/Deposit.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-depositable',
        name:'hub.depositable',
        component:() => import('./pages/Hub/Depositable.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-deposited',
        name:'hub.deposited',
        component:() => import('./pages/Hub/DepositedOrder.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-deposited-price-collection-gap',
        name:'hub.deposited.price_collection_gap',
        component:() => import('./pages/Hub/DepositedPriceCollectionGap.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-rider-assign',
        name:'hub.rider_assign',
        component:() => import('./pages/Hub/RiderAssign.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-rider-assigned-order',
        name:'hub.rider_assigned_order',
        component:() => import('./pages/Hub/RiderAssignedOrder.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/hub-rider-assigned-order-details',
        name:'hub.rider_assigned_order_details',
        component:() => import('./pages/Hub/AssignedOrderDetails.vue'),        
        meta: { requiresAuth:true }     
    },
    {
        path:'/bank',
        name:'bank',
        component:() => import('./pages/settings/Bank.vue'),     
        meta: { requiresAuth:true }         
    },
    {
        path:'/logistic-partner',
        name:'logistic_partner',
        component:() => import('./pages/settings/LogisticPartner.vue'),     
        meta: { requiresAuth:true }         
    },
    {
        path:'/area',
        name:'area',
        component:() => import('./pages/settings/Area.vue'),       
        meta: { requiresAuth:true }     
    },
    {
        path:'/banner',
        name:'banner',
        component:() => import('./pages/settings/Banner.vue'),       
        meta: { requiresAuth:true }     
    },
    {
        path:'/profile',
        name:'profile',
        component:() => import('./pages/settings/Profile.vue'),       
        meta: { requiresAuth:true }     
    },
    {
        path:'/district',
        name:'district',
        component:() => import('./pages/settings/District.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/thana',
        name:'thana',
        component:() => import('./pages/settings/Thana.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/zone',
        name:'zone',
        component:() => import('./pages/settings/Zone.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/zone-area',
        name:'zone.area',
        component:() => import('./pages/settings/ZoneArea.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/weight-charge',
        name:'WeightCharge',
        component:() => import('./pages/settings/WeightCharge.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/store',
        name:'store',
        component:() => import('./pages/settings/Store.vue'),      
        meta: { requiresAuth:true }      
    },
    {
        path:'/reason',
        name:'reason',
        component:() => import('./pages/settings/Reason.vue'),      
        meta: { requiresAuth:true }      
    },
    {
        path:'/issue',
        name:'issue',
        component: () => import('./pages/settings/issue/List.vue'),
        meta: { requiresAuth:true }
    },
    {
        path:'/complain',
        name:'complain',
        component: () => import('./pages/complain/Complain.vue'),
        meta: { requiresAuth:true }
    },
    // {
    //     path:'/merchant-charge',
    //     name:'merchant_charge',
    //     component:() => import('./pages/merchant/Charge.vue'),  
    //     props: {
    //         content: true
    //     },   
    //     meta: { requiresAuth:true }      
    // },
    {
        path:'/merchant',
        name:'merchant',
        component:() => import('./pages/merchant/Merchant.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/iregular-merchant',
        name:'iregular_merchant',
        component:() => import('./pages/merchant/IregularMerchant.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/merchant-account-change-request',
        name:'merchant_account_change_request',
        component:() => import('./pages/merchant/AccountChangeRequest.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/merchant-store-request',
        name:'merchant_store_request',
        component:() => import('./pages/merchant/StoreRequest.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/merchant-parcel-summary',
        name:'merchant_parcel_summary',
        component:() => import('./pages/merchant/ParcelSummary.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/merchant-parcel-summary-details',
        name:'merchant_parcel_summary_details',
        component:() => import('./pages/merchant/ParcelSummaryDetails.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/merchant-delivery-instruction',
        name:'merchant_delivery_instruction',
        component:() => import('./pages/merchant/DeliveryInstruction.vue'),     
        meta: { requiresAuth:true }      
    },
    {
        path:'/pickup',
        name:'pickup',
        component:() => import('./pages/pickup/Pickup.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/returnable',
        name:'returnable',
        component:() => import('./pages/return/Returnable.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/return',
        name:'return',
        component:() => import('./pages/return/List.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/return-cancel',
        name:'return.cancel',
        component:() => import('./pages/return/Cancel.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/make-return',
        name:'make.return',        
        props: true,
        component:() => import('./pages/return/Form.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/return-show',
        name:'return.show',
        component:() => import('./pages/return/Show.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/return-request',
        name:'return_request',
        component:() => import('./pages/return/ReturnRequest.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/hub-to-rtm',
        name:'hub_to_rtm',
        component:() => import('./pages/return/HubToRtm.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/hub-to-rtm-create',
        name:'hub_to_rtm_create',
        component:() => import('./pages/return/HubToRtmCreate.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/hub-to-rtm-details',
        name:'hub_to_rtm_details',
        component:() => import('./pages/return/HubToRtmDetails.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/rtm-to-hub',
        name:'rtm_to_hub',
        component:() => import('./pages/return/RtmToHub.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/rtm-to-hub-details',
        name:'rtm_to_hub_details',
        component:() => import('./pages/return/RtmToHubDetails.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/order-booking',
        name:'order.booking',
        component:() => import('./pages/order/Booking.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/order-process',
        name:'order.process',
        component:() => import('./pages/order/Process.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/price-changed-order',
        name:'order.price-changed',
        component:() => import('./pages/order/PriceChanged.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/manage-cancel-order',
        name:'order.manage_cancel_order',
        component:() => import('./pages/order/ManageCancelOrder.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/under-review',
        name:'under_reviewg',
        component:() => import('./pages/order/UnderReview.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/under-review-form',
        name:'under_review_form',
        component:() => import('./pages/order/UnderRevieForm.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/order-requesting',
        name:'order.requesting',
        component:() => import('./pages/order/Requesting.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/pathao',
        name:'pathao',
        component:() => import('./pages/order/Pathao.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/order',
        name:'order',
        component:() => import('./pages/order/Order.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/trash-order',
        name:'trash.order',
        component:() => import('./pages/order/Trash.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/issue-order',
        name:'issue.order',
        component:() => import('./pages/order/IssueOrder.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/lot',
        name:'lot',
        component:() => import('./pages/lot/Lot.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/lot-create',
        name:'lot.create',
        component:() => import('./pages/lot/LotCreate.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/lot-details',
        name:'lot.details',
        component:() => import('./pages/lot/Details.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/lot-missing-order',
        name:'lot_missing_order',
        component:() => import('./pages/lot/MissingOrder.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/deposit',
        name:'deposit',
        component:() => import('./pages/accounts/Deposit.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/payment-request',
        name:'payment.request',
        component:() => import('./pages/accounts/PaymentRequest.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/due',
        name:'due',
        component:() => import('./pages/accounts/Due.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/make-payment/:id?',
        name:'makePayment',
        component:() => import('./pages/accounts/MakePaymentOrder.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/make-return/:id?',
        name:'makeReturn',
        component:() => import('./pages/accounts/MakePaymentOrder.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/show-order',
        name:'show-order',
        component:() => import('./pages/accounts/ShowOrder.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/paid',
        name:'paid',
        component:() => import('./pages/accounts/Paid.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/invoice',
        name:'invoice',
        component:() => import('./pages/accounts/Invoice.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/collection',
        name:'collection',
        component:() => import('./pages/accounts/Collection.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/final-collection',
        name:'final_collection',
        component:() => import('./pages/accounts/FinalCollection.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/charge-adjust',
        name:'charge_adjust',
        component:() => import('./pages/accounts/ChargeAdjust.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/collection-report',
        name:'collection_report',
        component:() => import('./pages/accounts/CollectionReport.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/adjustment',
        name:'adjustment',
        component:() => import('./pages/accounts/Adjustment.vue'),     
        meta: { requiresAuth:true }       
    },
    {
        path:'/role',
        name:'role',
        component: () => import('./pages/user-management/Role.vue'),
        meta: { requiresAuth:true }    
    },
    {
        path:'/user',
        name:'user',
        component: () => import('./pages/user-management/User.vue'),
        meta: { requiresAuth:true }  
    },
    {
        path:'/edit-user',
        name:'editUser',
        component:() => import('./pages/user-management/EditUser.vue'),
        meta: { requiresAuth:true }  
    },
    {
        path:'/menu-privilege',
        name:'menu_privilege',
        component:() => import('./pages/user-management/MenuPrivilege.vue'),
        meta: { requiresAuth:true }  
    },
    {
        path:'/fraud',
        name:'fraud',
        component: () => import('./pages/fraud/Fraud.vue'),          
        meta: { requiresAuth:true }    
    },
    {
        path:'/notice',
        name:'notice',
        component: () => import('./pages/settings/Notice.vue'),          
        meta: { requiresAuth:true }    
    },
    {
        path:'/order-report',
        name:'order.report',
        component: () => import('./pages/report/OrderReport.vue'),     
    },
    {
        path:'/return-pending-report',
        name:'return.pending_report',
        component: () => import('./pages/report/ReturnPendingReport.vue'),     
    },
    {
        path:'/issue-tracker-report',
        name:'return.issue_tracker_report',
        component: () => import('./pages/report/IssueTrackerReport.vue'),     
    },
    {
        path:'/excel-log-report',
        name:'report.excel_log_report',
        component: () => import('./pages/report/ExcelLogReport.vue'),     
    },
    {     
        path:'/wrong-status',
        name:'wrong_status',
        component: () => import('./pages/settings/WrongStatus.vue'),          
        meta: { requiresAuth:true }    
    },
    {
        path:'/zonal',
        name:'zonal',
        component: () => import('./pages/settings/Zonal.vue'),          
        meta: { requiresAuth:true }    
    },
    {
        path:'/trash-order-fix',
        name:'trash_order_fix',
        component: () => import('./pages/order/TrashOrderFix.vue'),          
        meta: { requiresAuth:true }    
    },
]

const routes = [
    {
        path: '/auth',
        name: 'auth',
        component: () => import('@/layouts/AuthLayout.vue'),
        meta: { auth: false },
        children: authChildRoutes('auth')
    },    
    {
        path: '/',
        name: 'main',
        component: () => import('@/layouts/MainLayout.vue'),
        meta: { auth: false },
        children: otherRoutes()
    },    
    {
        path: '*',
        component: () => import('@/pages/NotFoundPage.vue'),
        meta: { hideNavigation: true }
    }
];

export const router = new VueRouter({
    mode: "history",
    hash: false,
    base: process.env.BASE_URL,
    hashbang: false,
    routes
})
  
router.beforeEach((to, from, next) => {  
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            next({
                path: '/auth/login',
                query: { redirect: to.fullPath }
            })
        } else if (to.path === from.path) {
            next();
        } else {
            // role wise menu permission check (blocks urls changed manually in browser)
            const roleId = Store.state.authUser.role_id
            const home = [1, 2, 6].includes(roleId) ? '/' : (roleId == 7 ? '/hub-dashboard' : '/operational-dashboard')
            if (to.path === home) {
                next()
                return
            }
            config.getData('/admin/check-menu-access', { path: to.path }).then(response => {
                if (response && response.allowed === false) {
                    Vue.prototype.$toast.error({
                        title: 'Error',
                        message: "You don't have the permission to use it",
                        color: '#dc3545'
                    })
                    // first load by typing url has no previous page to stay on
                    from.matched.length ? next(false) : next(home)
                } else {
                    next()
                }
            }).catch(() => next())
        }
    } else {
      next();
    }
})

export default router
